import { observer, inject } from 'mobx-react';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import { Pharmacy } from '../../store/models/Pharmacy';
import { Municipality } from '../../store/models/Municipality';
import { Instance } from 'mobx-state-tree';
import { PharmacyDetails, PharmacyDetails as PharmacyDetailsEx } from '../../store/models/PharmacyDetails';
import { SystemStatus } from '../../store/models/SystemStatus';

import { AuthenticationStore, MunicipalityStore, PharmacyDetailedStore, PharmacyStore, UiStore } from '../../store';
import { Form } from 'react-final-form';
import { PharmacySelectionDetailsTransfer } from './PharmacySelectionDetailsTransfer';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { NewAddressForm } from './NewAddressForm';
import PharmagardeMap from '../common/map/PharmagardeMap';
import { GoogleMap, Circle, Polygon, Marker, InfoWindow } from '@react-google-maps/api';
import PharmacyMarker from '../common/PharmacyMarker';
import { generateCustomIcon } from '../../common/icons';
import { getCoordinatesFromAddress } from '../../api/OpenStreetMapApi';
import { Checkbox, Tooltip, Position, Classes, Button } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import { getHERECoordinatesFromAddress, getHEREAddressFromCoordinates } from '../../api/HEREApi';
import { TranslatedMessage } from '../common/translation';
import * as geolib from 'geolib';

import { IconNames } from '@blueprintjs/icons';

import proj4 from 'proj4';
import { css } from 'glamor';
import { AddUserDefinedCircleDialog } from './AddUserDefinedCircleDialog';

interface TransferWithFusionTabProps extends WithTranslateProps {
  onPharmacyToCloseSelected: (value) => void;
  onPharmacyToTransferSelected: (value) => void;
  onSave: () => void;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  pharmacyNeighboringList: Array<Instance<typeof PharmacyDetailsEx>>;
  getPharmacyById: (id) => any;
  pharmacyUser: boolean;
  systemStatus?: Array<Instance<typeof SystemStatus>>;
  requesterDutiesSelected: number[];
  neighborDutiesSelected: number[];
  withAgreement?: boolean;
  withoutSubstitution?: boolean;
  comment?: string;
  onWithoutSubstitutionChange: () => void;
  onWithAgreementChange: () => void;
  onCommentChange: (value) => void;
  requestorDutiesIsLoading?: boolean;
  neighborDutiesIsLoading?: boolean;
  exchangeIsSaving?: boolean;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  MunicipalityStore?: Instance<typeof MunicipalityStore>;
  UiStore?: Instance<typeof UiStore>;
}

interface TransferWithFusionTabState {
  notification: string;
  showWithoutSubstitution: boolean;
  buttonCalculateNewCoordinatesDisabled: boolean;
  pharmacyToCloseSelected?: Instance<typeof PharmacyDetails>;
  pharmacyToTransferSelected?: Instance<typeof PharmacyDetails>;
  isNewLocationSelected: boolean;
  newLat?: number;
  newLong?: number;
  newMainMunicipality?: Instance<typeof Municipality>;
  initialZoomCalculated: boolean;
  nbrOfNeighbors: number;
  showProtectionCircles: boolean;
  showDefaultProtectionCircles: boolean;
  showTemporaryProtectionCircles: boolean;
  isVerified?: boolean;
  sourceMunicipality?: Instance<typeof Municipality>;
  sourcePharmacyCount: number;
  targetMunicipality?: Instance<typeof Municipality>;
  targetPharmacyCount: number;
  isInsideMoveCircle?: boolean;
  isOutsideProtectionCircles?: boolean;
  authorizedMoveRadius: number;
  defaultProtections: { pharmacyId: number; radius: number }[];
  openMunicipalityDialog: boolean;
  selectedMunicipality: Instance<typeof Municipality>;
  hasUserChangedZoomOrCenter: boolean;
  zoom: number | undefined;
  mapCenterLat: number | undefined;
  mapCenterLong: number | undefined;
  map: google.maps.Map | undefined;
  newPositionMarkerInfoVisible: boolean;
  userAddedCircles: any[] | undefined;
  openAddCircleDialog: boolean;
  userAddedCircleLat: number | undefined;
  userAddedCircleLng: number | undefined;
}

@inject('AuthenticationStore', 'PharmacyDetailedStore', 'PharmacyStore', 'UiStore', 'MunicipalityStore')
@observer
class TransferWithFusionTab extends React.Component<TransferWithFusionTabProps, TransferWithFusionTabState> {
  state = {
    notification: '',
    showWithoutSubstitution: true,
    buttonCalculateNewCoordinatesDisabled: true,
    nbrOfNeighbors: 10,
    showProtectionCircles: true,
    showDefaultProtectionCircles: true,
    showTemporaryProtectionCircles: true,
    isNewLocationSelected: false,
    isVerified: undefined,
    authorizedMoveRadius: 3000,
    openMunicipalityDialog: false,
    hasUserChangedZoomOrCenter: false,
    zoom: undefined,
    mapCenterLat: 50.58603,
    mapCenterLong: 3.806026,
    map: undefined,
    newPositionMarkerInfoVisible: false,
    userAddedCircles: undefined,
    openAddCircleDialog: false,
    userAddedCircleLat: undefined,
    userAddedCircleLng: undefined,
  } as TransferWithFusionTabState;

  wgs84 = 'EPSG:4326';
  lambert2008 = 'EPSG:3812';

  getIsDirty = () => {
    // const { requesterDutiesSelected, neighborDutiesSelected } = this.props;

    return false; //requesterDutiesSelected.length > 0 || neighborDutiesSelected.length > 0;
  };

  somethingToSave = () => {
    // const {
    //   requesterDutiesSelected,
    //   neighborDutiesSelected,
    //   withoutSubstitution,
    //   withAgreement,
    //   pharmacyUser,
    // } = this.props;
    // const ready =
    //   (!pharmacyUser || withAgreement) &&
    //   (requesterDutiesSelected.length > 0 || neighborDutiesSelected.length > 0) &&
    //   (neighborDutiesSelected.length > 0 || withoutSubstitution);
    return true; //ready;
  };

  red = 'DC143C';
  green = '7CFC00';
  yellow = 'e9ff00';
  blue = '1528f2';
  protectionColor = '#fc0d05';
  defaultProtectionColor = '#ec9ff4';
  authorizedColor = '7CFC00';

  yellowBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: '#' + this.yellow,
    },
    '.bp3-button:hover': {
      backgroundColor: '#' + this.yellow,
    },
  });

  blueBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: 'blue',
    },
    '.bp3-button:hover': {
      backgroundColor: 'blue',
    },
  });

  greenBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: 'green',
    },
    '.bp3-button:hover': {
      backgroundColor: 'green',
    },
  });

  redBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: '#' + this.red,
    },
    '.bp3-button:hover': {
      backgroundColor: '#' + this.red,
    },
  });

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  closeIcon = (showBullet: boolean) =>
    generateCustomIcon(20, 20, this.red, this.red, showBullet, '000000', false, '888888', '1', '1');
  moveIcon = (showBullet: boolean) =>
    generateCustomIcon(20, 20, this.green, this.green, showBullet, '000000', false, '888888', '1', '1');
  neighborIcon = (showBullet: boolean) =>
    generateCustomIcon(14, 14, this.yellow, this.yellow, showBullet, '000000', false, '888888', '1', '1');
  targetIcon = generateCustomIcon(20, 20, this.blue, this.blue, true, '000000', false, '888888', '1', '1');
  greyNeighborIcon = (showBullet: boolean) =>
    generateCustomIcon(14, 14, 'CACFD2', 'CACFD2', showBullet, '000000', false, '888888', '1', '1');

  private toggleNewPositionMarkerInfo = () => {
    const currentState = !this.state.newPositionMarkerInfoVisible;
    this.setState({ newPositionMarkerInfoVisible: currentState });
  };

  private openAddCircleToMarkerDialog = (lat: number, lng: number) => {
    this.setState({ openAddCircleDialog: true, userAddedCircleLat: lat, userAddedCircleLng: lng });
  };

  private onCircleAdded = (lat: number, lng: number, radius: number) => {
    const circle = (
      <Circle
        key={'cicrcle-' + lat + lng + radius}
        center={{ lat, lng }}
        radius={radius}
        options={{
          fillColor: '#ADD8E6',
          strokeWeight: 0.5,
        }}
        onRightClick={(e) => {
          google.maps.event.trigger(this.state.map, 'rightclick', e);
        }}
      />
    );
    if (this.state.userAddedCircles === undefined) this.setState({ userAddedCircles: [circle] });
    else this.setState({ userAddedCircles: [...this.state.userAddedCircles, circle] });
  };

  renderPharmacyMarkers = () =>  {
    const { pharmacyToTransferSelected, pharmacyToCloseSelected } = this.state;
    // const { pharmaciesList, groupList } = this.props;
    const pharmacyList: any = [];
    if (pharmacyToCloseSelected !== undefined) pharmacyList.push(pharmacyToCloseSelected);
    if (pharmacyToTransferSelected !== undefined) pharmacyList.push(pharmacyToTransferSelected);

    let markers: any = [];

    if (pharmacyToCloseSelected) {
      const pharmacyToCloseMarker = (
        <PharmacyMarker
          key={pharmacyToCloseSelected.pharmacyId}
          id={pharmacyToCloseSelected.pharmacyId}
          marker={pharmacyToCloseSelected}
          zIndex={100}
          icon={this.closeIcon(pharmacyToCloseSelected.level === 3)}
          groupEditMode={false}
          onAddCircle={this.openAddCircleToMarkerDialog}
          disableRightClick
        />
      );
      markers.push(pharmacyToCloseMarker);

      const pharmacyCircle = (
        <Circle
          key={'circle-' + pharmacyToCloseSelected.pharmacyId}
          center={{
            lat: pharmacyToCloseSelected!.latitude as number,
            lng: pharmacyToCloseSelected!.longitude as number,
          }}
          radius={this.state.authorizedMoveRadius}
          options={{
            fillColor: 'green', //this.authorizedColor, //'#106BA3',
            strokeWeight: 0.5,
          }}
          onRightClick={(e) => {
            google.maps.event.trigger(this.state.map, 'rightclick', e);
          }}
        />
      );
      // markers.push(pharmacyCircle);
    }

    if (pharmacyToTransferSelected) {
      const pharmacyToTransferMarker = (
        <PharmacyMarker
          key={pharmacyToTransferSelected.pharmacyId}
          id={pharmacyToTransferSelected.pharmacyId}
          marker={pharmacyToTransferSelected}
          zIndex={100}
          icon={this.moveIcon(pharmacyToTransferSelected.level === 3)}
          groupEditMode={false}
          onAddCircle={this.openAddCircleToMarkerDialog}
          disableRightClick
        />
      );
      markers.push(pharmacyToTransferMarker);

      const pharmacyCircle = (
        <Circle
          key={'circle-' + pharmacyToTransferSelected.pharmacyId}
          center={{
            lat: pharmacyToTransferSelected!.latitude as number,
            lng: pharmacyToTransferSelected!.longitude as number,
          }}
          radius={this.state.authorizedMoveRadius}
          options={{
            fillColor: 'green', //this.authorizedColor, //'#106BA3',
            strokeWeight: 0.5,
          }}
          onRightClick={(e) => {
            google.maps.event.trigger(this.state.map, 'rightclick', e);
          }}
        />
      );
      markers.push(pharmacyCircle);

      //@ts-ignore
      const neighbors1 = pharmacyToTransferSelected.pharmacyNeighbors
        .filter((n) => n.distance !== undefined && n.distance < 6000)
        .sort((a: any, b: any) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));

      //@ts-ignore
      const neighbors2 = pharmacyToCloseSelected.pharmacyNeighbors
        .filter((n) => n.distance !== undefined && n.distance < 6000)
        .sort((a: any, b: any) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));

      const neighbors = neighbors1.concat(neighbors2);

      let defaultProtectionCircles: any = [];
      neighbors.forEach((item) => {
        const neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
        if (
          neighbor &&
          (pharmacyToCloseSelected == undefined || pharmacyToCloseSelected.pharmacyId != neighbor.pharmacyId) &&
          (pharmacyToTransferSelected == undefined || pharmacyToTransferSelected.pharmacyId != neighbor.pharmacyId)
        ) {
          console.log("" + neighbor.apbNumber + " " + item.distance);
          const neighborMarker = (
            <PharmacyMarker
              key={neighbor.pharmacyId}
              id={neighbor.pharmacyId}
              marker={neighbor}
              zIndex={100}
              icon={
                neighbor.isActive
                  ? this.neighborIcon(neighbor.level === 3)
                  : this.greyNeighborIcon(neighbor.level === 3)
              }
              groupEditMode={false}
              protections={neighbor.protections.filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())}
              onAddCircle={this.openAddCircleToMarkerDialog}
              disableRightClick
            />
          );
          markers.push(neighborMarker);
          this.drawDefaultProtectionCircle(neighbor, markers);
        }
      });
    }

    const newPosition = (
      <Marker
        key={'target'}
        position={{
          lat: this.state.newLat as number, //pharmacyToTransferSelected!.latitude! + 0.0032,
          lng: this.state.newLong as number, //pharmacyToTransferSelected!.longitude! - 0.0005,
        }}
        icon={this.targetIcon}
        onClick={this.toggleNewPositionMarkerInfo}
      >
        {this.state.newPositionMarkerInfoVisible && (
          <InfoWindow onCloseClick={this.toggleNewPositionMarkerInfo} options={{ disableAutoPan: true }}>
            <div style={{ minWidth: '250px', minHeight: '70px' }}>
              <DivLine>
                <b>{this.props.translate(TLCode.PHARMACY_Latitude) + ':'}</b>
                {' ' + this.state.newLat}
              </DivLine>
              <DivLine>
                <b>{this.props.translate(TLCode.PHARMACY_Longitude) + ':'}</b>
                {' ' + this.state.newLong}
              </DivLine>
              <DivLine
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                }}
              >
                <Button
                  style={{ fontSize: 12 }}
                  text={this.props.translate(TLCode.TRANSFER_AddCircleDialogTitle)}
                  onClick={() => {
                    this.toggleNewPositionMarkerInfo();
                    this.openAddCircleToMarkerDialog(this.state.newLat!, this.state.newLong!);
                  }}
                />
              </DivLine>
            </div>
          </InfoWindow>
        )}
      </Marker>
    );
    markers.push(newPosition);

    return markers;
  };

  drawDefaultProtectionCircle = (neighbor, markers) => {
    let municipality = this.props.MunicipalityStore!.dataList.find((m) => m.municipalityId == neighbor.municipalityId);
    // default protection 100, 500, 1000 m for population >30K, [7.5K-30K], < 7.5K
    let defaultCircleRadius = 500;

    try {
      if (municipality && municipality.population > 30000) {
        defaultCircleRadius = 100;
      } else if (municipality && municipality.population < 7500) {
        defaultCircleRadius = 1000;
      }
    } catch (e) {
      console.log('error');
    }

    let defaultProtectionCircle = (
      <>
        {this.state.showDefaultProtectionCircles && (
          <Circle
            key={'min' + neighbor.pharmacyId}
            center={{ lat: neighbor.latitude, lng: neighbor.longitude }}
            radius={defaultCircleRadius}
            options={{
              fillColor: this.defaultProtectionColor,
              strokeWeight: 0.4,
              strokeOpacity: 0.5,
            }}
            onRightClick={(e) => {
              google.maps.event.trigger(this.state.map, 'rightclick', e);
            }}
          />
        )}
      </>
    );

    markers.push(defaultProtectionCircle);

    // protection after transfer or fusion
    if (this.hasProtection(neighbor)) {
      neighbor.protections
        .filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())
        .forEach((element) => {
          let protectedCircle = (
            <>
              {this.state.showTemporaryProtectionCircles && (
                <Circle
                  key={'min' + neighbor.pharmacyId}
                  center={{ lat: neighbor.latitude, lng: neighbor.longitude }}
                  radius={element.range}
                  options={{
                    fillColor: this.protectionColor, //'red',

                    strokeWeight: 0.4,

                    strokeOpacity: 0.5,
                  }}
                  onRightClick={(e) => {
                    google.maps.event.trigger(this.state.map, 'rightclick', e);
                  }}
                />
              )}
            </>
          );

          markers.push(protectedCircle);
        });
    }

    return { pharmacyId: neighbor.pharmacyId, radius: defaultCircleRadius };
  };

  hasProtection = (pharmacy) => {
    const res = pharmacy.protections.length > 0;
    return res;
  };

  isProtected = (pharmacy) => {
    return true;
  };

  verifyCoordinates = () => {
    //TODO
    //this.setState({ isVerified: true });
  };

  VerifyTransfer = () => {
    let isVerified;

    if (this.state.sourceMunicipality != undefined && this.state.targetMunicipality == undefined) {
      // target not specified
      isVerified = undefined;
    } else if (
      this.state.sourceMunicipality != undefined &&
      this.state.targetMunicipality != undefined &&
      this.state.sourceMunicipality.mainINSCode == this.state.targetMunicipality.mainINSCode
    ) {
      // stay in same municipality
      isVerified = true;
    } else if (this.state.sourcePharmacyCount > 1) {
      // change of municipality => check final pharmacy count in source municipality
      isVerified = true;
    } else {
      isVerified = false;
    }

    this.IsInsideCircles();
    this.IsOutsideAllProtectionCircles();

    // this.setState({ isVerified: isVerified && this.state.isInsideMoveCircle && this.state.isOutsideProtectionCircles?true:false });
  };

  IsInsideCircles = () => {
    if (this.state.isNewLocationSelected) {
      // y-a-t-il déplacement,
      const isInSourceCircle = this.IsInsideCircle(
        this.state.pharmacyToCloseSelected,
        this.state.newLong,
        this.state.newLat,
        this.state.authorizedMoveRadius,
      );
      const isInTargetCircle = this.IsInsideCircle(
        this.state.pharmacyToTransferSelected,
        this.state.newLong,
        this.state.newLat,
        this.state.authorizedMoveRadius,
      );
      this.setState({
        isInsideMoveCircle: isInSourceCircle || isInTargetCircle,
        isVerified: (isInSourceCircle || isInTargetCircle) && this.state.isOutsideProtectionCircles!,
      });
    } else this.setState({ isInsideMoveCircle: true, isVerified: this.state.isOutsideProtectionCircles! });
  };

  IsInsideCircle = (center, newLong, newLat, diam) => {
    console.log('isInsideCircle?');
    // if (T) {
    var result = geolib.isPointWithinRadius(
      { latitude: newLat, longitude: newLong },
      { latitude: center.latitude, longitude: center.longitude },
      diam,
    );
    return result;
    // } else return false;
  };

  IsOutsideAllProtectionCircles = () => {
    // ne s'applique que si la pharmacie restante change d'emplacement
    // comme l'emplacement est dans un cercle de 3000m autour d'un des deux emplacements de départ,
    // on doit regarder les protections des voisines des pharmacies d e départ dans un rayon adéquat (3000M + dim de protection max)
    if (this.state.isNewLocationSelected) {
      const toCloseNeighbors = (this.state.pharmacyToCloseSelected as any).pharmacyNeighbors.sort((a, b) =>
        a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0,
      );
      const toTransferNeighbors = (this.state.pharmacyToTransferSelected as any).pharmacyNeighbors.sort((a, b) =>
        a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0,
      );

      let isOutsideProtectionCircles = true;
      toTransferNeighbors.forEach((item) => {
        if (
          item.neighborId != this.state.pharmacyToCloseSelected!.pharmacyId &&
          item.neighborId != this.state.pharmacyToTransferSelected!.pharmacyId
        ) {
          var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
          if (neighbor) {
            const flag = this.IsOutsideSpecificProtectionCircles(this.state.newLong, this.state.newLat, neighbor);
            if (!flag) isOutsideProtectionCircles = false;
          }
        }
      });
      toTransferNeighbors.forEach((item) => {
        if (
          item.neighborId != this.state.pharmacyToCloseSelected!.pharmacyId &&
          item.neighborId != this.state.pharmacyToTransferSelected!.pharmacyId &&
          item.distance <= 5000
        ) {
          var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
          if (neighbor && neighbor.municipalityId) {
            var defaultProtectionCircle = this.drawDefaultProtectionCircle(neighbor, []);
            if (defaultProtectionCircle) {
              const isInDefaultProtectionCircle = this.IsInsideCircle(
                neighbor,
                this.state.newLong,
                this.state.newLat,
                defaultProtectionCircle.radius,
              );
              if (isInDefaultProtectionCircle) {
                isOutsideProtectionCircles = false;
              }
            }
          }
        }
      });

      toCloseNeighbors.forEach((item) => {
        if (
          item.neighborId != this.state.pharmacyToCloseSelected!.pharmacyId &&
          item.neighborId != this.state.pharmacyToTransferSelected!.pharmacyId
        ) {
          var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
          if (neighbor) {
            const flag = this.IsOutsideSpecificProtectionCircles(this.state.newLong, this.state.newLat, neighbor);
            if (!flag) isOutsideProtectionCircles = false;
          }
        }
      });
      toCloseNeighbors.forEach((item) => {
        if (
          item.neighborId != this.state.pharmacyToCloseSelected!.pharmacyId &&
          item.neighborId != this.state.pharmacyToTransferSelected!.pharmacyId &&
          item.distance <= 5000
        ) {
          var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
          if (neighbor && neighbor.municipalityId) {
            var defaultProtectionCircle = this.drawDefaultProtectionCircle(neighbor, []);
            if (defaultProtectionCircle) {
              const isInDefaultProtectionCircle = this.IsInsideCircle(
                neighbor,
                this.state.newLong,
                this.state.newLat,
                defaultProtectionCircle.radius,
              );
              if (isInDefaultProtectionCircle) {
                isOutsideProtectionCircles = false;
              }
            }
          }
        }
      });

      // if (this.state.isOutsideProtectionCircles != isOutsideProtectionCircles) {
      this.setState({
        isOutsideProtectionCircles: isOutsideProtectionCircles,
        isVerified: this.state.isInsideMoveCircle && isOutsideProtectionCircles ? true : false,
      });
      // }
    }
  };

  IsOutsideSpecificProtectionCircles = (newLong, newLat, neighbor) => {
    // if (newLocation) {
    var outside = true;
    if (neighbor.pharmacyId == this.state.pharmacyToCloseSelected!.pharmacyId) return true;
    if (neighbor.pharmacyId == this.state.pharmacyToTransferSelected!.pharmacyId) return true;
    if (neighbor.protections) {
      neighbor.protections
        .filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())
        .map((pr) => {
          var result = geolib.isPointWithinRadius(
            { latitude: newLat, longitude: newLong },
            { latitude: neighbor.latitude, longitude: neighbor.longitude },
            pr.range,
          );
          if (result) {
            outside = false;
          }
        });
    }
    return outside;
    // } else return this.state.isOutsideProtectionCircles;
  };

  centerAndZoom = (centerLat: number, centerLong: number, includeNeighbors: boolean = false) => {
    this.setState({ hasUserChangedZoomOrCenter: false });
    this.calculateZoom(centerLat, centerLong, includeNeighbors);
  };

  calculateZoom = (centerLat: number, centerLong: number, includeNeighbors: boolean = false) => {
    if (this.state.map !== undefined) {
      let currentMarkerPositions: google.maps.LatLng[] = [];
      var bounds = new google.maps.LatLngBounds();
      var hasBoundExtended = false;

      const pharmacyDetails = this.state.pharmacyToTransferSelected;

      if (pharmacyDetails !== undefined) {
        // Add selected pharmacy position
        currentMarkerPositions.push(
          new google.maps.LatLng(pharmacyDetails.latitude as number, pharmacyDetails.longitude as number),
        );

        if (includeNeighbors)
          //add neighbors position
          pharmacyDetails.pharmacyNeighbors
            .slice()
            .sort((a, b) =>
              (a.distance as number) > (b.distance as number)
                ? 1
                : (b.distance as number) > (a.distance as number)
                ? -1
                : 0,
            )
            .slice(0, this.state.nbrOfNeighbors)
            .forEach((item) => {
              var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
              if (neighbor) {
                currentMarkerPositions.push(
                  new google.maps.LatLng(neighbor.latitude as number, neighbor.longitude as number),
                );
              }
            });
      }

      const pharmacyToCloseDetails = this.state.pharmacyToCloseSelected;

      if (pharmacyToCloseDetails !== undefined) {
        // Add selected pharmacy position
        currentMarkerPositions.push(
          new google.maps.LatLng(pharmacyToCloseDetails.latitude as number, pharmacyToCloseDetails.longitude as number),
        );

        if (includeNeighbors)
          //add neighbors position
          pharmacyToCloseDetails.pharmacyNeighbors
            .slice()
            .sort((a, b) =>
              (a.distance as number) > (b.distance as number)
                ? 1
                : (b.distance as number) > (a.distance as number)
                ? -1
                : 0,
            )
            .slice(0, this.state.nbrOfNeighbors)
            .forEach((item) => {
              var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
              if (neighbor) {
                currentMarkerPositions.push(
                  new google.maps.LatLng(neighbor.latitude as number, neighbor.longitude as number),
                );
              }
            });
      }

      // Add new address position
      if (this.state.isNewLocationSelected && !Number.isNaN(this.state.newLat) && !Number.isNaN(this.state.newLong))
        currentMarkerPositions.push(new google.maps.LatLng(Number(this.state.newLat), Number(this.state.newLong)));

      //Fit the bounds of the map to include the marker positions
      for (var i = 0; i < currentMarkerPositions.length; i++) {
        var marker = currentMarkerPositions[i];

        if (marker !== undefined) {
          bounds.extend(marker);
          hasBoundExtended = true;
        }
      }
      if (hasBoundExtended && this.state.map) {
        this.state.map.fitBounds(bounds);
        this.setState({ mapCenterLat: centerLat, mapCenterLong: centerLong });
        var newbounds = this.state.map.getBounds();
        if (newbounds === undefined) return;
        for (i = 0; i < currentMarkerPositions.length; i++) {
          if (!newbounds.contains(currentMarkerPositions[i])) {
            const mapZoom = this.state.map.getZoom();
            if (mapZoom === undefined) return;
            this.state.zoom = mapZoom - 1;
            break;
          }
        }
      }
    }
  };

  public render() {
    const { translate, onSave, pharmacyList, getPharmacyById, pharmacyUser } = this.props;
    const { mapCenterLong, mapCenterLat } = this.state;
    const isVerified = this.state.isVerified;

    const dirty = this.getIsDirty();

    const initialZoomCalculated = this.state.initialZoomCalculated;

    const getPharmacyCountByMunicipality = async (municipality: Instance<typeof Municipality>) => {
      var count:any = await this.props.PharmacyStore!.getPharmacyCountByMainMunicipality(municipality.mainINSCode);
      return count;
      /*
      // NOK parce que le detailedStore ne contient pas les pharmacies à ce stade
      const municipalityPharmacyList = this.props.PharmacyDetailedStore!.dataList.filter(
        (ph) => ph.municipality && ph.municipality!.mainINSCode == municipality.mainINSCode,
      );
      return municipalityPharmacyList.length;
      */
    };

    const getClosingPharmacyCountByMunicipality = async (municipality: Instance<typeof Municipality>) => {
      var count:any = await this.props.PharmacyStore!.getPharmacyCountByMainMunicipality(municipality.mainINSCode);
      this._isMounted && this.setState({ sourcePharmacyCount: count });
    }

    const getToTransferPharmacyCountByMunicipality = async (municipality: Instance<typeof Municipality>) => {
      var count:any = await this.props.PharmacyStore!.getPharmacyCountByMainMunicipality(municipality.mainINSCode);
      this._isMounted && this.setState({ targetMunicipality: municipality, targetPharmacyCount: parseInt(count) });
    }


    const onPharmacyToCloseSelected = async (pharmacyToClose: Instance<typeof Pharmacy>) => {
      await this.props.PharmacyDetailedStore!.loadElement(pharmacyToClose.pharmacyId)!;
      const pharmacyDetails = this.props.PharmacyDetailedStore!.getByIdOrNew(pharmacyToClose.pharmacyId);
      this._isMounted &&
        this.setState({
          pharmacyToCloseSelected: pharmacyDetails,
          sourcePharmacyCount: -1
        });

      await this.props.PharmacyDetailedStore!.loadNeighboringPharmacies(pharmacyDetails.pharmacyId);
      const neighbors = pharmacyDetails.pharmacyNeighbors
        .filter((n) => n.distance < 6000)
        .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));

      //Load neighbors to display
      neighbors.slice(0).forEach(async (item) => {
        // neighbors.slice(0, this.state.nbrOfNeighbors).forEach(async (item) => {
        const isPharmacyLoaded = this.props.PharmacyDetailedStore!.getById(item.neighborId) !== undefined;
        if (!isPharmacyLoaded) await this.props.PharmacyDetailedStore!.loadElement(item.neighborId);
      });

      pharmacyDetails.pharmacyNeighbors.map((ph) => {
        if (ph !== undefined && ph.pharmacyId !== undefined) {
          var pharmacy = this.props.PharmacyDetailedStore!.getById(ph.pharmacyId);
          if (pharmacy !== undefined && pharmacy!.municipalityId !== undefined)
            ph.municipality = this.props.MunicipalityStore!.getById(pharmacy!.municipalityId!);
        }
      });

      //get source main municipality
      const closingPhMunicipality = this.props.MunicipalityStore!.getById(pharmacyDetails.municipalityId);
      this._isMounted && this.setState({ sourceMunicipality: closingPhMunicipality });
      if (closingPhMunicipality !== undefined) {
        const closingPhMainMunicipality = this.props.MunicipalityStore!.dataList.find(
          (item) => item.isMain && item.mainINSCode == closingPhMunicipality.mainINSCode,
        );
        if (closingPhMainMunicipality !== undefined) {
          //var count:any = getPharmacyCountByMunicipality(closingPhMainMunicipality);
          //this._isMounted && this.setState({ sourcePharmacyCount: parseInt(count) });
          getClosingPharmacyCountByMunicipality(closingPhMainMunicipality);
        }
      }

      this.VerifyTransfer();
    };

    const onPharmacyToTransferSelected = async (pharmacyToTransfer: Instance<typeof Pharmacy>) => {
      console.log('loading pharmacy to transfer with id ' + pharmacyToTransfer.pharmacyId);
      await this.props.PharmacyDetailedStore!.loadElement(pharmacyToTransfer.pharmacyId)!;
      const pharmacyDetails = this.props.PharmacyDetailedStore!.getByIdOrNew(pharmacyToTransfer.pharmacyId);
      this._isMounted &&
        this.setState({
          pharmacyToTransferSelected: pharmacyDetails,
          targetPharmacyCount: -1
        });

      await this.props.PharmacyDetailedStore!.loadNeighboringPharmacies(pharmacyDetails.pharmacyId);
      const neighbors = pharmacyDetails.pharmacyNeighbors
        .filter((n) => n.distance < 6000)
        .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));

      //Load neighbors to display
      neighbors.slice(0).forEach(async (item) => {
        // neighbors.slice(0, this.state.nbrOfNeighbors).forEach(async (item) => {
        const isPharmacyLoaded = this.props.PharmacyDetailedStore!.getById(item.neighborId) !== undefined;
        if (!isPharmacyLoaded) {
          await this.props.PharmacyDetailedStore!.loadElement(item.neighborId);
          // const isPharmacyLoaded2 = this.props.PharmacyDetailedStore!.getById(item.neighborId) !== undefined;
        }
      });

      pharmacyDetails.pharmacyNeighbors.map((ph) => {
        if (ph !== undefined && ph.pharmacyId !== undefined) {
          var pharmacy = this.props.PharmacyDetailedStore!.getById(ph.pharmacyId);
          if (pharmacy !== undefined && pharmacy!.municipalityId !== undefined)
            ph.municipality = this.props.MunicipalityStore!.getById(pharmacy!.municipalityId!);
        }
      });

      //get source main municipality
      const targetMunicipality = this.props.MunicipalityStore!.getById(pharmacyDetails.municipalityId);
      if (targetMunicipality != undefined) {
        //var count: any = getPharmacyCountByMunicipality(targetMunicipality);
        //this._isMounted && this.setState({ targetMunicipality: targetMunicipality, targetPharmacyCount: parseInt(count) });
        getToTransferPharmacyCountByMunicipality(targetMunicipality);
      }

      this.VerifyTransfer();
    };

    const calculateCoordinates = async (address: string): Promise<[number, number, typeof Municipality]> => {
      let lat: number = 0;
      let long: number = 0;
      let city: string = '';
      let district: string = '';
      let postalCode: number = 0;
      let entity: typeof Municipality;
      this.verifyCoordinates();
      await getHERECoordinatesFromAddress(address)
        .then((result) => {
          if (result === undefined) {
            return;
          }
          if (result[0].resultType == 'houseNumber') {
            lat = Number(result[0].position.lat);
            long = Number(result[0].position.lng);
            city = result[0].address.city;
            district = result[0].address.district !== undefined ? result[0].address.district : '';
            postalCode =
              result[0].address.postalCode !== undefined && !isNaN(Number(result[0].address.postalCode))
                ? Number(result[0].address.postalCode)
                : 0;

            const municipality = district && district.length > 0 ? district.toUpperCase() : city.toUpperCase();

            const final = this.props.MunicipalityStore!.dataList.filter(
              (item) => item.postalCode == postalCode
              // (item) => item.postalCode == postalCode && item.mainNameFR == city && item.nameFR == municipality,
            );

            if (final.length === 0 || final[0] === undefined) {
              return;
            }

            //@ts-ignore
            processNewAddress(result[0].position.lat, result[0].position.lng, final[0]);
            //@ts-ignore
            entity = final[0];
          }
        })
        //await getTomTomCoordinatesFromAddress(address)
        // await getCoordinatesFromAddress(address)
        // .then((result) => {
        //   if (result.length !== 0) {
        //     lat = Number(result![0].lat);
        //     long = Number(result![0].lon);
        //     processNewAddress(result![0].lat, result![0].lon);
        //   }
        // })
        .catch();

      //@ts-ignore
      return [lat, long, entity];
    };

    const processNewAddress = (newLat: string, newLong: string, newMunicipality: Instance<typeof Municipality>) => {
      var count: any = getPharmacyCountByMunicipality(newMunicipality);
      this.setState({
        isNewLocationSelected: true,
        newLat: parseFloat(newLat),
        newLong: parseFloat(newLong),
        targetMunicipality: newMunicipality,
        targetPharmacyCount: count,
        newMainMunicipality: newMunicipality,
      });

      this.VerifyTransfer();
    };

    const fromLambert2008ToWGS84 = (x: number, y: number): [number, number] => {
      //lambert2008
      proj4.defs(
        'EPSG:3812',
        '+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      );
      const result = proj4(this.lambert2008, this.wgs84, [x, y]);
      const lat = result[1];
      const lng = result[0];

      return [lat, lng];
    };

    const fromWGS84ToLambert2008 = (lat: number, long: number): [number, number] => {
      //lambert2008
      proj4.defs(
        'EPSG:3812',
        '+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      );
      const result = proj4(this.wgs84, this.lambert2008, [long, lat]);
      const x = result[0];
      const y = result[1];

      return [x, y];
    };

    const calculateFromLambert2008ToWGS84 = async (x: number, y: number): Promise<[number, number]> => {
      const wgs84Coordinates = fromLambert2008ToWGS84(x, y);
      const lat = wgs84Coordinates[0];
      const lng = wgs84Coordinates[1];

      await getHEREAddressFromCoordinates(lat.toString(), lng.toString()).then((result) => {
        if (result.status == 200) {
          const mnp = this.props.MunicipalityStore!.dataList.find(
            (mn) =>
              mn.mainNameFR == result.data.items[0].address.city &&
              mn.postalCode == result.data.items[0].address.postalCode,
          );
          if (this.state.pharmacyToTransferSelected === undefined) return;
          if (mnp === undefined) {
            this._isMounted && this.setState({ openMunicipalityDialog: true, newLat: lat, newLong: lng });
            return;
          }
          processNewAddress(lat.toString(), lng.toString(), mnp!);
        }
      });
      return wgs84Coordinates;
    };

    return (
      <>
        <AddUserDefinedCircleDialog
          isOpen={this.state.openAddCircleDialog}
          onClose={() => {
            this.setState({ openAddCircleDialog: false });
          }}
          circleLat={this.state.userAddedCircleLat !== undefined ? this.state.userAddedCircleLat : 0}
          circleLng={this.state.userAddedCircleLng !== undefined ? this.state.userAddedCircleLng : 0}
          onCircleAdd={this.onCircleAdded}
        />
        <Container>
          <div>
            {
              //TODO : set inital values and TYPE of form
            }
            <Form
              initialValues={{}}
              onSubmit={onSave}
              render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
                <form onSubmit={handleSubmit}>
                  <FormContainer>
                    <>
                      <DivLine>
                        <PharmacySelectionDetailsTransfer
                          pharmacyLabelCode={TLCode.TRANSFER_PharmacyToClose}
                          pharmacyList={
                            pharmacyList.filter((item) => item.level >= 0) as Array<Instance<typeof Pharmacy>>
                          }
                          onChange={onPharmacyToCloseSelected}
                          getPharmacyById={getPharmacyById}
                          pharmacySelected={this.state.pharmacyToCloseSelected}
                          pharmacyLabelColor={'red'}
                          withEntityAndNbrPharmacy={true}
                          nbrPharmacies = {this.state.sourcePharmacyCount>=0?this.state.sourcePharmacyCount:undefined}
                          translate={translate}
                          convertWGS84ToLambert2008={fromWGS84ToLambert2008}
                        />
                      </DivLine>
                      <DivLine>
                        <PharmacySelectionDetailsTransfer
                          pharmacyLabelCode={TLCode.TRANSFER_PharmacyToTransfer}
                          pharmacyList={
                            pharmacyList.filter((item) => item.level >= 0) as Array<Instance<typeof Pharmacy>>
                          }
                          onChange={onPharmacyToTransferSelected}
                          getPharmacyById={getPharmacyById}
                          pharmacySelected={this.state.pharmacyToTransferSelected}
                          pharmacyLabelColor={'green'}
                          pharmacyTextColor={'white'}
                          withEntityAndNbrPharmacy={true}
                          nbrPharmacies={this.state.targetPharmacyCount>=0?this.state.targetPharmacyCount:undefined}
                          translate={translate}
                          convertWGS84ToLambert2008={fromWGS84ToLambert2008}
                        />
                      </DivLine>
                      <DivLine>
                        <NewAddressForm
                          calculateCoordinates={calculateCoordinates}
                          convertLambert2008ToWGS84={calculateFromLambert2008ToWGS84}
                          convertWGS84ToLambert2008={fromWGS84ToLambert2008}
                          translate={translate}
                          pharmacyLabelColor={'blue'}
                          pharmacyTextColor={'white'}
                        />
                        {isVerified && (
                          <>
                            <DivLine style={{ backgroundColor: 'green', color: 'white' }}>
                              &nbsp;Localisation autorisée&nbsp;
                            </DivLine>
                          </>
                        )}
                        {isVerified != undefined && !isVerified && (
                          <>
                            <DivLine style={{ backgroundColor: 'red', color: 'white' }}>
                              &nbsp;Localisation interdite&nbsp;
                            </DivLine>
                          </>
                        )}
                      </DivLine>
                      {isVerified != undefined && (
                        <DivLine>
                          <DivColumn style={{ width: '300px' }}>
                            <Checkbox
                              label={translate(TLCode.TRANSFER_InsideMoveCircles)}
                              checked={this.state.isInsideMoveCircle}
                              disabled
                            />
                          </DivColumn>
                          <DivColumn style={{ width: '300px' }}>
                            <Checkbox
                              label={translate(TLCode.TRANSFER_OutsideProtectedCircles)}
                              checked={this.state.isOutsideProtectionCircles}
                              disabled
                            />
                          </DivColumn>
                          <DivColumn></DivColumn>
                        </DivLine>
                      )}
                    </>
                  </FormContainer>
                </form>
              )}
            />
          </div>
          <LeaveRouteDirtyWrapper blockChange={dirty} />
          &nbsp;&nbsp;
          <DivLine style={{ height: '100%' }}>
            <DivColumn style={{ width: '100%', height: '100%', paddingRight: '5px' }}>
              <PharmagardeMap
                center={
                  mapCenterLat === undefined || mapCenterLong === undefined
                    ? undefined
                    : { lat: mapCenterLat, lng: mapCenterLong }
                }
                onLoad={(map: google.maps.Map) => {
                  this.setState({ map });
                  this.setState({ initialZoomCalculated: true });
                }}
                gridSize={5}
                maximalZoom={18}
                minimalZoom={8}
                initialZoom={18}
                onRightClick={async (event) => {
                  if (this.state.pharmacyToTransferSelected === undefined) return;

                  if (event === null || event.latLng === null) return;
                  await getHEREAddressFromCoordinates(
                    event.latLng.lat().toString(),
                    event.latLng.lng().toString(),
                  ).then((result) => {
                    if (result.status == 200) {
                      const mnp = this.props.MunicipalityStore!.dataList.find(
                        (mn) =>
                          mn.mainNameFR == result.data.items[0].address.city &&
                          mn.postalCode == result.data.items[0].address.postalCode,
                      );
                      if (this.state.pharmacyToTransferSelected == undefined) return;
                      if (event === null || event.latLng === null) return;
                      const roundedLat = Math.round(event.latLng.lat() * 1000000) / 1000000;
                      const roundedLng = Math.round(event.latLng.lng() * 1000000) / 1000000;
                      if (mnp === undefined) {
                        this._isMounted &&
                          this.setState({
                            openMunicipalityDialog: true,
                            newLat: roundedLat,
                            newLong: roundedLng,
                          });
                        return;
                      }
                      processNewAddress(roundedLat.toString(), roundedLng.toString(), mnp!);
                      this.calculateZoom(roundedLat, roundedLng);
                    }
                  });
                }}
              >
                {initialZoomCalculated
                  ? this.state.userAddedCircles !== undefined
                    ? [...this.renderPharmacyMarkers(), ...this.state.userAddedCircles]
                    : [...this.renderPharmacyMarkers()]
                  : undefined}
              </PharmagardeMap>
            </DivColumn>
            <DivColumn style={{ width: '150px' }}>
              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <DivLine>
                    <Tooltip2
                      content={
                        <Tooltip2Style>
                          <TranslatedMessage id={TLCode.TRANSFER_PermanentProtection} />
                        </Tooltip2Style>
                      }
                      position={Position.BOTTOM}
                    >
                      <Checkbox
                        label={translate(TLCode.TRANSFER_ShowDefaultProtectionCircles)}
                        onChange={() =>
                          this.setState({ showDefaultProtectionCircles: !this.state.showDefaultProtectionCircles })
                        }
                        checked={
                          this.state.showDefaultProtectionCircles !== undefined
                            ? this.state.showDefaultProtectionCircles
                            : false
                        }
                      />
                    </Tooltip2>
                  </DivLine>
                  <DivLine style={{ width: '150px', marginTop: '10px' }}>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomPharmacy)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.pharmacyToTransferSelected !== undefined &&
                            this.state.pharmacyToTransferSelected.latitude !== undefined &&
                            this.state.pharmacyToTransferSelected.longitude !== undefined
                          ) {
                            this.centerAndZoom(
                              this.state.pharmacyToTransferSelected.latitude!,
                              this.state.pharmacyToTransferSelected.longitude!,
                              true,
                            );
                          }
                        }}
                        className={this.greenBackgroundColor.toString()}
                      />
                    </Tooltip>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomHalfHalf)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        onClick={() => {
                          if (
                            this.state.pharmacyToTransferSelected !== undefined &&
                            this.state.pharmacyToTransferSelected.latitude !== undefined &&
                            this.state.pharmacyToTransferSelected.longitude !== undefined &&
                            this.state.pharmacyToCloseSelected !== undefined &&
                            this.state.pharmacyToCloseSelected.latitude !== undefined &&
                            this.state.pharmacyToCloseSelected.longitude !== undefined
                          ) {
                            this.centerAndZoom(
                              (this.state.pharmacyToTransferSelected.latitude! +
                                Number(this.state.pharmacyToCloseSelected.latitude!)) /
                                2,
                              (this.state.pharmacyToTransferSelected.longitude! +
                                Number(this.state.pharmacyToCloseSelected.longitude!)) /
                                2,
                              true,
                            );
                          }
                        }}
                        text="1/2"
                      />
                    </Tooltip>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomClose)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.pharmacyToCloseSelected !== undefined &&
                            this.state.pharmacyToCloseSelected.latitude !== undefined &&
                            this.state.pharmacyToCloseSelected.longitude !== undefined
                          ) {
                            this.centerAndZoom(
                              Number(this.state.pharmacyToCloseSelected.latitude!),
                              Number(this.state.pharmacyToCloseSelected.longitude!),
                              true,
                            );
                          }
                        }}
                        className={this.redBackgroundColor.toString()}
                      />
                    </Tooltip>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomDestination)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.isNewLocationSelected &&
                            this.state.newLat !== undefined &&
                            this.state.newLong !== undefined
                          ) {
                            this.centerAndZoom(this.state.newLat!, this.state.newLong!, true);
                          }
                        }}
                        className={this.blueBackgroundColor.toString()}
                      />
                    </Tooltip>
                  </DivLine>
                </DivColumn>
              </DivLine>
              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <Tooltip2
                    content={
                      <Tooltip2Style>
                        <TranslatedMessage id={TLCode.TRANSFER_TemporaryProtection} />
                      </Tooltip2Style>
                    }
                    position={Position.BOTTOM}
                  >
                    <Checkbox
                      label={translate(TLCode.TRANSFER_ShowTemporaryProtectionCircles)}
                      onChange={() =>
                        this.setState({ showTemporaryProtectionCircles: !this.state.showTemporaryProtectionCircles })
                      }
                      checked={
                        this.state.showTemporaryProtectionCircles !== undefined
                          ? this.state.showTemporaryProtectionCircles
                          : false
                      }
                    />
                  </Tooltip2>
                </DivColumn>
              </DivLine>
            </DivColumn>
          </DivLine>
        </Container>
      </>
    );
  }
}

export default withTranslate(TransferWithFusionTab);

const Tooltip2Style = styled.div`
  max-width: 200px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
